var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.contract }
        },
        [
          _c("table", { staticClass: "custom-tbl error-prompt" }, [
            _c("thead", { staticClass: "head" }, [
              _c("tr", { staticClass: "row" }, [
                _c("th", [_vm._v("阶段名称")]),
                _vm._v(" "),
                _vm.contractType == _vm.integPurch.value && _vm.offline
                  ? _c("th", { attrs: { width: "140" } }, [
                      _vm._v("质保起算时间")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("th", { attrs: { width: "110" } }, [_vm._v("绝对时间")]),
                _vm._v(" "),
                _c("th", { attrs: { width: "140" } }, [_vm._v("时长")]),
                _vm._v(" "),
                _c("th", { attrs: { width: "100" } }, [
                  _vm._v("付款账期("),
                  _c("span", { staticClass: "font-red" }, [_vm._v("天")]),
                  _vm._v(")")
                ]),
                _vm._v(" "),
                _c("th", { attrs: { width: "100" } }, [
                  _vm._v("支付金额("),
                  _c("span", { staticClass: "font-red" }, [_vm._v("%")]),
                  _vm._v(")")
                ]),
                _vm._v(" "),
                _c("th", { attrs: { width: "100" } }, [
                  _vm._v("支付金额("),
                  _c("span", { staticClass: "font-red" }, [_vm._v("元")]),
                  _vm._v(")")
                ]),
                _vm._v(" "),
                _vm.contractType == _vm.integPurch.value
                  ? _c("th", { attrs: { width: "120" } }, [
                      _vm._v("商品交付件数("),
                      _c("span", { staticClass: "font-red" }, [_vm._v("%")]),
                      _vm._v(")")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.contractType == _vm.integPurch.value
                  ? _c("th", { attrs: { width: "130" } }, [
                      _vm._v("预计商品交付件数")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("th", { attrs: { width: "80" } }, [_vm._v("当前阶段")]),
                _vm._v(" "),
                _c("th", { attrs: { width: "100" } }, [_vm._v("操作")])
              ])
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              { staticClass: "body" },
              _vm._l(_vm.contract.contractTrackPhaseList, function(
                contractTrackPhase,
                index
              ) {
                return _c("tr", { staticClass: "row" }, [
                  _c(
                    "td",
                    [
                      _c(
                        "el-form-item",
                        {
                          key: contractTrackPhase.id,
                          attrs: {
                            prop: "contractTrackPhaseList." + index + ".name",
                            rules: {
                              required: true,
                              type: "string",
                              message: "阶段名称不能为空",
                              trigger: "blur"
                            }
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.disabledInput(contractTrackPhase)
                            },
                            on: {
                              blur: function($event) {
                                _vm.changeName(contractTrackPhase, index)
                              }
                            },
                            model: {
                              value: contractTrackPhase.name,
                              callback: function($$v) {
                                _vm.$set(contractTrackPhase, "name", $$v)
                              },
                              expression: "contractTrackPhase.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.contractType == _vm.integPurch.value && _vm.offline
                    ? _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              key: contractTrackPhase.id,
                              attrs: {
                                prop:
                                  "contractTrackPhaseList." +
                                  index +
                                  ".wrntPeriodStartTime",
                                rules: {
                                  required: true,
                                  type: "date",
                                  message: "请选择时间",
                                  trigger: "change"
                                }
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "120px" },
                                attrs: {
                                  disabled: _vm.disabledInput(
                                    contractTrackPhase
                                  ),
                                  type: "date",
                                  format: "yyyy-MM-dd",
                                  placeholder: "选择日期",
                                  "picker-options":
                                    _vm.wrntPeriodStartTimeOptions
                                },
                                model: {
                                  value: contractTrackPhase.wrntPeriodStartTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      contractTrackPhase,
                                      "wrntPeriodStartTime",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "contractTrackPhase.wrntPeriodStartTime"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("el-switch", {
                        attrs: {
                          disabled: _vm.disabledInput(contractTrackPhase),
                          "on-color": "#13ce66",
                          "off-color": "#ff4949"
                        },
                        on: {
                          change: function($event) {
                            _vm.changeDueDate(contractTrackPhase)
                          }
                        },
                        model: {
                          value: contractTrackPhase.absDate,
                          callback: function($$v) {
                            _vm.$set(contractTrackPhase, "absDate", $$v)
                          },
                          expression: "contractTrackPhase.absDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("td", [
                    !contractTrackPhase.absDate ||
                    contractTrackPhase.absDate == "false"
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              {
                                key: contractTrackPhase.id,
                                staticClass: "inline-block",
                                staticStyle: { width: "110px" },
                                attrs: {
                                  prop:
                                    "contractTrackPhaseList." +
                                    index +
                                    ".incrDays",
                                  rules: {
                                    validator: _vm.validateIntNotNull,
                                    trigger: "blur"
                                  }
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.disabledInput(
                                      contractTrackPhase
                                    )
                                  },
                                  model: {
                                    value: contractTrackPhase.incrDays,
                                    callback: function($$v) {
                                      _vm.$set(
                                        contractTrackPhase,
                                        "incrDays",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "contractTrackPhase.incrDays"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v("天")])
                          ],
                          1
                        )
                      : _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              {
                                key: contractTrackPhase.id,
                                attrs: {
                                  prop:
                                    "contractTrackPhaseList." +
                                    index +
                                    ".dueDate",
                                  rules: {
                                    required: true,
                                    type: "date",
                                    message: "请选择时间",
                                    trigger: "change"
                                  }
                                }
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "120px" },
                                  attrs: {
                                    disabled: _vm.disabledInput(
                                      contractTrackPhase
                                    ),
                                    type: "date",
                                    format: "yyyy-MM-dd",
                                    placeholder: "选择日期"
                                  },
                                  model: {
                                    value: contractTrackPhase.dueDate,
                                    callback: function($$v) {
                                      _vm.$set(
                                        contractTrackPhase,
                                        "dueDate",
                                        $$v
                                      )
                                    },
                                    expression: "contractTrackPhase.dueDate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "el-form-item",
                        {
                          key: contractTrackPhase.id,
                          attrs: {
                            prop:
                              "contractTrackPhaseList." + index + ".payDays",
                            rules: {
                              validator: _vm.validateIntNotNull,
                              trigger: "blur"
                            }
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.disabledInput(contractTrackPhase)
                            },
                            model: {
                              value: contractTrackPhase.payDays,
                              callback: function($$v) {
                                _vm.$set(
                                  contractTrackPhase,
                                  "payDays",
                                  _vm._n($$v)
                                )
                              },
                              expression: "contractTrackPhase.payDays"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "el-form-item",
                        {
                          key: contractTrackPhase.id,
                          attrs: {
                            prop:
                              "contractTrackPhaseList." +
                              index +
                              ".amountPayPct",
                            rules: {
                              validator: _vm.validateNumber,
                              trigger: "change"
                            }
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              max: "100",
                              disabled: _vm.disabledInput(contractTrackPhase)
                            },
                            on: {
                              change: function($event) {
                                _vm.amountPayValue(contractTrackPhase)
                              }
                            },
                            model: {
                              value: contractTrackPhase.amountPayPct,
                              callback: function($$v) {
                                _vm.$set(
                                  contractTrackPhase,
                                  "amountPayPct",
                                  _vm._n($$v)
                                )
                              },
                              expression: "contractTrackPhase.amountPayPct"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "el-form-item",
                        {
                          key: contractTrackPhase.id,
                          attrs: {
                            prop:
                              "contractTrackPhaseList." + index + ".amountPay",
                            rules: {
                              validator: _vm.validateMoneyStr,
                              trigger: "change"
                            }
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.disabledInput(contractTrackPhase)
                            },
                            on: {
                              change: function($event) {
                                _vm.amountPayPctValue(contractTrackPhase)
                              }
                            },
                            model: {
                              value: contractTrackPhase.amountPay,
                              callback: function($$v) {
                                _vm.$set(
                                  contractTrackPhase,
                                  "amountPay",
                                  _vm._n($$v)
                                )
                              },
                              expression: "contractTrackPhase.amountPay"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.contractType == _vm.integPurch.value
                    ? _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              key: contractTrackPhase.id,
                              attrs: {
                                prop:
                                  "contractTrackPhaseList." +
                                  index +
                                  ".goodsDeliverCountPct",
                                rules: {
                                  validator: _vm.validateNumber,
                                  trigger: "change"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  max: "100",
                                  disabled: _vm.disabledInput(
                                    contractTrackPhase
                                  )
                                },
                                on: {
                                  change: function($event) {
                                    _vm.goodsDeliverCountValue(
                                      contractTrackPhase
                                    )
                                  }
                                },
                                model: {
                                  value:
                                    contractTrackPhase.goodsDeliverCountPct,
                                  callback: function($$v) {
                                    _vm.$set(
                                      contractTrackPhase,
                                      "goodsDeliverCountPct",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "contractTrackPhase.goodsDeliverCountPct"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contractType == _vm.integPurch.value
                    ? _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              key: contractTrackPhase.id,
                              attrs: {
                                prop:
                                  "contractTrackPhaseList." +
                                  index +
                                  ".goodsDeliverCount",
                                rules: {
                                  validator: _vm.validateIntStr,
                                  trigger: "change"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.disabledInput(
                                    contractTrackPhase
                                  )
                                },
                                on: {
                                  change: function($event) {
                                    _vm.goodsDeliverCountPctValue(
                                      contractTrackPhase
                                    )
                                  }
                                },
                                model: {
                                  value: contractTrackPhase.goodsDeliverCount,
                                  callback: function($$v) {
                                    _vm.$set(
                                      contractTrackPhase,
                                      "goodsDeliverCount",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "contractTrackPhase.goodsDeliverCount"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("td", [
                    contractTrackPhase.ended
                      ? _c("span", [_vm._v("已结束")])
                      : _vm._e(),
                    _vm._v(" "),
                    contractTrackPhase.active
                      ? _c("span", [_vm._v("是")])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    !contractTrackPhase.ended &&
                    ((!_vm.contract.confirmed && _vm.operate != "chakan") ||
                      (_vm.operate == "change" &&
                        (contractTrackPhase.id == null ||
                          !contractTrackPhase.active)))
                      ? _c(
                          "a",
                          {
                            staticClass: "swb-btn-link ml10",
                            on: {
                              click: function($event) {
                                _vm.removeContractTrackPhase(index)
                              }
                            }
                          },
                          [_vm._v("移除")]
                        )
                      : _vm._e()
                  ])
                ])
              })
            ),
            _vm._v(" "),
            _vm.operate != "chakan"
              ? _c("tfoot", { staticClass: "foot" }, [
                  _c("tr", { staticClass: "row" }, [
                    _vm.contractType == _vm.integPurch.value && !_vm.offline
                      ? _c("td", { attrs: { colspan: "10" } }, [
                          _c(
                            "a",
                            {
                              staticClass: "swb-btn-link",
                              on: { click: _vm.addContractTrackPhase }
                            },
                            [_vm._v("+ 合同计划阶段")]
                          )
                        ])
                      : _vm.contractType == _vm.integPurch.value && _vm.offline
                      ? _c("td", { attrs: { colspan: "11" } }, [
                          _c(
                            "a",
                            {
                              staticClass: "swb-btn-link",
                              on: { click: _vm.addContractTrackPhase }
                            },
                            [_vm._v("+ 合同计划阶段")]
                          )
                        ])
                      : _c("td", { attrs: { colspan: "8" } }, [
                          _c(
                            "a",
                            {
                              staticClass: "swb-btn-link",
                              on: { click: _vm.addContractTrackPhase }
                            },
                            [_vm._v("+ 合同计划阶段")]
                          )
                        ])
                  ])
                ])
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b4bad9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b4bad9a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/contract/ContractTrackPhase.vue
// module id = 1791
// module chunks = 1